
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hooks/useDraggable.html",
      function () {
        return require("private-next-pages/Hooks/useDraggable.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hooks/useDraggable.html"])
      });
    }
  